import { render, staticRenderFns } from "./BlockingRuleTable.vue?vue&type=template&id=0122c66a&"
import script from "./BlockingRuleTable.vue?vue&type=script&lang=js&"
export * from "./BlockingRuleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports